import { generateMethodDecorator } from "@/app/core/decorator/generateMethodDecorator";

const LifeCycle = generateMethodDecorator([]);
export default LifeCycle;
